import { useTranslation } from "react-i18next";

import Button from "components/Button";
import { Dialog, DialogContent, DialogFooter, DialogHeader } from "components/Dialog";
import { Form, FormField } from "components/Form";
import Input from "components/Input";
import Label from "components/Label";
import Textarea from "components/Textarea";

import type { ContactUsDialogProps } from "./ContactUsDialog.types";
import useContactUsDialog from "./useContactUsDialog";

export default function ContactUsDialog({ open, setOpen, packageId }: ContactUsDialogProps) {
  const { t } = useTranslation();

  const { form, control, handleSubmit, onSubmit } = useContactUsDialog({ setOpen, packageId });

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>{t("checkout.contactUsDialog.title")}</DialogHeader>
        <Form {...form}>
          <form onSubmit={handleSubmit(onSubmit)} id="contact-form">
            <div className="flex flex-col gap-6 max-w-[670px] w-full mx-auto pb-8 flex-1 overflow-visible">
              <div className="flex flex-col gap-2.5">
                <div className="flex flex-col gap-3.5">
                  <FormField
                    control={control}
                    name="firstName"
                    render={({ field }) => (
                      <Input
                        {...field}
                        label={t("checkout.contactUsDialog.firstName")}
                        placeholder={t("checkout.contactUsDialog.firstName")}
                      />
                    )}
                  />
                  <FormField
                    control={control}
                    name="lastName"
                    render={({ field }) => (
                      <Input
                        {...field}
                        label={t("checkout.contactUsDialog.lastName")}
                        placeholder={t("checkout.contactUsDialog.lastName")}
                      />
                    )}
                  />

                  <FormField
                    control={control}
                    name="email"
                    render={({ field }) => (
                      <Input
                        {...field}
                        label={t("checkout.contactUsDialog.email")}
                        placeholder={t("checkout.contactUsDialog.email")}
                      />
                    )}
                  />
                  <FormField
                    control={control}
                    name="message"
                    render={({ field }) => (
                      <div className="flex flex-col gap-2">
                        <Label htmlFor={field.name}>{t("checkout.contactUsDialog.message")}</Label>
                        <Textarea {...field} />
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
          </form>
        </Form>
        <DialogFooter className="justify-between gap-2">
          <Button
            type="button"
            variant="destructiveOutline"
            className="w-full flex-1"
            onClick={() => {
              setOpen(false);
            }}
          >
            {t("button.cancel")}
          </Button>

          <Button className="w-full flex-1" type="submit" form="contact-form">
            {t("button.send")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
